import {mainAPI,} from "../api";
import {NotificationsListResponse, Notification, UnreadNotificationsCount} from "../types/notifications";

export function fetchNotificationsList(limit: number, offset: number): Promise<Array<Notification>> {
    return mainAPI.get<NotificationsListResponse>(
        `notifications/`,
        {
            params: {
                limit, offset,
            }
        }
    ).then(
        (res) => {
            return Promise.resolve(res.data.results);
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}


export function readNotification(pk: string): Promise<Notification> {
    return mainAPI.post<Notification>(
        `notifications/${pk}/read/`,
    ).then(
        (res) => {
            return Promise.resolve(res.data);
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}

export function deleteAllNotification(): Promise<any> {
    return mainAPI.delete<any>(
        `notifications/delete_all/`,
    ).then(
        (res) => {
            return Promise.resolve();
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}

export function readAllNotification(): Promise<any> {
    return mainAPI.post<any>(
        `notifications/read_all/`,
    ).then(
        (res) => {
            return Promise.resolve();
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}

export function fetchNotificationsUnreadAmount(): Promise<UnreadNotificationsCount> {
    return mainAPI.get<UnreadNotificationsCount>(
        `notifications/amount_of_unread/`,
    ).then(
        (res) => {
            return Promise.resolve(res.data);
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}

export function sendPushToken(token: string, jwt: string): Promise<any> {
    return mainAPI.post<any>(
        `fcm_devices/`,
        {
            name: "string",
            registration_id: token,
            // "device_id": "string",
            active: true,
            type: "web"
        },
        { // Переопределяем заголовок с JWT, так как после авторизации не успевает проставиться в localStorage
            headers: {
                Authorization: `Bearer ${jwt}`
            }
        }
    ).then(
        (res) => {
            localStorage.setItem("xFcmToken", token);  // храним зарегистрированный токен чтобы удалить именно его
            return Promise.resolve(res);
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}

export function removePushToken(token: string): Promise<any> {
    return mainAPI.delete<any>(
        `fcm_devices/${token}/`,
    ).then(
        (res) => {
            localStorage.removeItem("xFcmToken");  // токен снят с бэка чистим локально
            return Promise.resolve(res);
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}

